'use es6';

import { Map as ImmutableMap } from 'immutable';
import Actions from 'AdsUI/lib/Actions';
import { TrackerTypeToRecord } from 'AdsUI/records/rmf/AdWordsConversionTrackerEntityRecords';
export default ((state = ImmutableMap(), action) => {
  const {
    type,
    payload = []
  } = action;
  let recType;

  switch (type) {
    case Actions.ADWORDS_CONVERSION_TRACKERS_FETCH_SUCCEEDED:
      // iterate, find type of the tracker, map to record
      state = state.withMutations(s => {
        payload.forEach(tracker => {
          recType = TrackerTypeToRecord[tracker.trackerType];
          s.set(tracker.id, new recType(tracker));
        });
      });
      break;

    case Actions.ADWORDS_CONVERSION_TRACKERS_SAVE_SUCCEEDED:
      recType = TrackerTypeToRecord[payload.trackerType];
      state = recType ? state.set(payload.id, new recType(payload)) : state;
      break;

    case Actions.ADWORDS_CONVERSION_TRACKERS_SYNC_SUCCEEDED:
      {
        // add the new one to state, delete old ID since immutable.
        state = state.delete(payload.oldId);

        if (payload.newTracker) {
          const newTracker = payload.newTracker;
          recType = TrackerTypeToRecord[newTracker.trackerType];
          state = state.set(newTracker.id, new recType(newTracker));
        }

        break;
      }

    default:
      break;
  }

  return state;
});